export default "__VITE_ASSET__cb26efc7__"